import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 18 14",
  "content": "<symbol viewBox=\"0 0 18 14\" id=\"twitter\">\n    <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M17.355 2.04a7.176 7.176 0 0 1-1.718 1.77 9.729 9.729 0 0 1-.392 3.197 9.943 9.943 0 0 1-1.225 2.635c-.547.841-1.2 1.585-1.956 2.232-.756.647-1.668 1.163-2.735 1.548A10.011 10.011 0 0 1 5.904 14c-1.916 0-3.669-.512-5.259-1.537.247.028.523.042.827.042 1.59 0 3.008-.488 4.252-1.463a3.339 3.339 0 0 1-1.994-.684 3.35 3.35 0 0 1-1.208-1.691c.233.035.449.053.647.053.303 0 .604-.039.9-.117a3.37 3.37 0 0 1-1.966-1.182 3.309 3.309 0 0 1-.78-2.179V5.2c.481.268.997.413 1.549.434a3.42 3.42 0 0 1-1.114-1.219 3.337 3.337 0 0 1-.413-1.633c0-.622.155-1.198.466-1.728a9.708 9.708 0 0 0 3.123 2.529 9.542 9.542 0 0 0 3.939 1.055 3.804 3.804 0 0 1-.085-.785A3.3 3.3 0 0 1 9.79 1.431 3.3 3.3 0 0 1 12.213.429c.99 0 1.823.36 2.502 1.081a6.715 6.715 0 0 0 2.173-.827 3.325 3.325 0 0 1-1.505 1.887 6.824 6.824 0 0 0 1.972-.53z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/twitter.svg
// module id = ./src/assets/img/twitter.svg
// module chunks = 2